import React from 'react';
import { motion } from 'framer-motion';
import { Shield } from 'lucide-react';
export function Guarantee() {
  return <section className="py-24 px-6 bg-brand-bg" data-id="element-379">
      <div className="max-w-[600px] mx-auto" data-id="element-380">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-381">
          <div className="w-24 h-24 mx-auto rounded-full border-2 border-brand-gold bg-brand-gold/10 flex items-center justify-center mb-8 shadow-[0_0_30px_rgba(255,215,0,0.2)]" data-id="element-382">
            <span className="font-display text-4xl font-bold text-brand-gold" data-id="element-383">
              7
            </span>
          </div>

          <h2 className="text-3xl md:text-4xl font-black text-white mb-8" data-id="element-384">
            Garantía Blindada de 7 Días — Cero Riesgo
          </h2>

          <div className="bg-brand-card border-2 border-brand-gold rounded-[20px] p-8 md:p-10 shadow-[0_0_50px_rgba(255,215,0,0.1)] relative overflow-hidden" data-id="element-385">
            <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-br from-brand-gold/5 to-transparent pointer-events-none" data-id="element-386" />

            <p className="text-lg text-brand-muted leading-relaxed mb-6 relative z-10" data-id="element-387">
              Prueba el Bio-X 90 completo — ebook + app — durante 7 días. Si no
              sientes que el sistema te ayuda a ordenar tus hábitos, si no notas
              mejoras en tu energía diaria... o si simplemente no te gusta el
              tipo de letra del ebook — envíanos un email.
            </p>

            <p className="text-xl font-bold text-white mb-6 relative z-10" data-id="element-388">
              Te devolveremos cada centavo. Sin preguntas. Sin formularios. Sin
              excusas.
            </p>

            <p className="text-brand-gold italic font-medium relative z-10" data-id="element-389">
              El riesgo es 100% nuestro. Tu única responsabilidad es darle una
              oportunidad a tu biología.
            </p>
          </div>

          {/* Mid-page CTA */}
          <div className="mt-16 bg-brand-cyan/10 rounded-2xl p-8 border border-brand-cyan/20" data-id="element-390">
            <h4 className="text-xl font-bold text-white mb-6" data-id="element-391">
              ¿Listo para empezar?
            </h4>
            <a href="https://pay.hotmart.com/X105898119V" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center w-full sm:w-auto px-8 h-[56px] rounded-xl bg-gradient-to-r from-brand-cyan to-brand-purple text-white font-bold hover:scale-[1.02] transition-transform shadow-lg" data-id="element-392">
              Acceso completo por $6.36 →
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}